<template>
  <div class="bg_gray">
    <Header navTitle="我的授权码" navPath="/mobile/center"></Header>
    <LoadList :pager="pager" v-model:loading="loading" @getPager="getPager" v-if="!loading">
      <div v-if="orderList.length > 0" class="container bg_gray">
        <van-cell-group class="code_list" v-for="(item, index) in orderList" :key="index">
          <van-cell>
            <template #title>
              <div class="course_item_common">
                <div class="cover" @click="goPath('/mobile/course/detail/' + item.cur_uuid)">
                  <img :src="item.cover_image" />
                  <span class="hot" v-if="item.cover_image_label && item.cover_image_label != 'null'">{{item.cover_image_label}}</span>
                  <span class="tag" v-if="item.type">{{ item.type }}</span>
                </div>
                <div class="content">
                  <h4 @click="goPath('/mobile/course/detail/' + scope.row.cur_uuid)" class="text_ellipsis">{{ item.cur_name }}</h4>
                  <div class="info">
                    <div><i class="iconfont icon-tubiaocankaoxian1024-05"></i> {{ item.auth_name }}</div>
                    <div class="last">到期日期：{{item.expired_at}}</div>
                  </div>
                </div>
              </div>
            </template>
          </van-cell>
          <van-cell>
            <template #title>
              授权码 {{item.code}}
            </template>
          </van-cell>
        </van-cell-group>
      </div>
      <van-empty v-else description="暂无内容哦~" />
    </LoadList>
    <Overlay :isLoad="loading" :customStyle="{top: '60px'}"></Overlay>
  </div>
</template>

<script>
  import Header from 'components/mobile/common/Header'
  import LoadList from "components/mobile/common/LoadList"
  import { listUserCode } from "api/course/auth/list"
  import Overlay from 'components/mobile/common/Overlay'

  export default {
    components: {
      Header,
      LoadList,
      Overlay
    },
    data() {
      return {
        orderList: [],
        loading: true,
        loaded: false,
        pager: {
          currentPage: 0,
          pageSize: 10,
          total: 0,
        }
      }
    },
    mounted() {
      this.$emit('update:isShowHeader', false);
      this.listCode()
    },
    methods: {
      listCode() {
        const that = this
        let filter = {
          limit: this.pager.pageSize,
          offset: (this.pager.currentPage - 1) * this.pager.pageSize
        }
        listUserCode(filter).then(res => {
          that.orderList.push(...res.data)
          that.pager.total = res.total
          that.loading = false
        })
      },
      stateFormatter(row, column){
        if(row.code) {
          return dayjs(row.expired_at).format('YYYY-MM-DD HH:mm:ss')
        }
        else {
          return '授权码发放中'
        }
      },
      goPath(path) {
        this.$router.push(path)
      },
      getPager(pager) { //获取分页变化后数据
        this.pager = pager
        this.listCode()
      },
    }
  }
</script>

<style lang="scss" scoped>
  .container {
    padding:10px 0;
  }
  :deep(.code_list) {
    margin-bottom:10px;
    .van-cell__title {
      min-width: 0;
    }
  }
  .course_item_common {
    .cover {
      margin:0 10px 0 0;
    }
    .content {
      padding-top:10px;
      padding-right:0;
      padding-bottom:0;
      .info {
        .last {
          color:#666;
          margin-top:15px;
        }
      }
    }
  }
</style>
